// extracted by mini-css-extract-plugin
export var icon = "_ba-3";
export var subtitle = "_ba-2";
export var title = "_ba-1";
export var value = "_ba-0";